import { render, staticRenderFns } from "./advocacy.vue?vue&type=template&id=74873ba2&"
import script from "./advocacy.vue?vue&type=script&lang=js&"
export * from "./advocacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports